var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircledSyncBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2012_114006",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 0,
    width: 18,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3014 21.1231C9.89541 20.8885 9.75588 20.3693 9.98992 19.963L11.9401 16.5851C12.1472 16.2263 12.6058 16.1036 12.9645 16.3106C13.3232 16.5177 13.446 16.9763 13.2389 17.3351L12.1325 19.2511C14.591 19.2047 16.963 17.9085 18.2809 15.6261C20.1291 12.4248 19.2589 8.39862 16.3854 6.2247L16.3268 6.1749C16.0484 5.91612 16.0057 5.48361 16.2399 5.17392C16.4743 4.86429 16.9025 4.7877 17.2272 4.98545L17.2907 5.02842C20.7598 7.65309 21.8116 12.5115 19.5807 16.3761C18.0712 18.9904 15.4162 20.53 12.6178 20.7296L14.4294 21.7745C14.7877 21.9817 14.9108 22.4404 14.7038 22.7989C14.4967 23.1575 14.038 23.2802 13.6794 23.0733L10.3014 21.1231ZM6.40007 18.7013C3.13608 15.9892 2.27209 11.3525 4.4323 7.61045C5.94162 4.99623 8.59612 3.45795 11.3942 3.25791L9.58464 2.21201C9.22592 2.0049 9.10312 1.54534 9.31023 1.18662C9.51746 0.828276 9.97609 0.705212 10.3346 0.912205L13.7126 2.8624C14.1187 3.09716 14.2575 3.61716 14.0231 4.02353L12.0729 7.40146C11.8657 7.75996 11.4071 7.88291 11.0485 7.67588C10.6899 7.46881 10.5671 7.01016 10.7741 6.65146L11.8796 4.73642C9.42126 4.78326 7.04884 6.07811 5.73113 8.36045C3.93817 11.4665 4.65278 15.3007 7.35906 17.5489L7.62761 17.7618C7.95786 18.0117 8.02284 18.4813 7.77312 18.8116C7.52337 19.1418 7.05364 19.2075 6.72331 18.9581L6.40007 18.7013Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2012_114006)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#0A7CC1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircledSyncBack);
export default __webpack_public_path__ + "static/media/circled-sync-back.79d447329e373ef8eaba59fea458acd1.svg";
export { ForwardRef as ReactComponent };